module.exports = __webpack_public_path__ + "static/media/report_5.2cc31d67.png";